type ProfileWithRelatedTag = {
	related_tag?: ({ item?: { id?: string | null } | null } | null)[] | null;
};

// A dashboard profile is only usable when its related artist/geotag carries an
// id: the saved-tags heart sends that id to Cognito, and it is the field the
// KV cache entries written before May 2026 are missing. An entry without it is
// stale and must not be served as a profile.
export const hasProfileTagId = (
	profile: ProfileWithRelatedTag | null | undefined
) => Boolean(profile?.related_tag?.[0]?.item?.id);
